module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v("An Amish Christmas")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe.page-template+xml"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "p0524-01-0"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page518"
    }
  }, [_c('i', [_vm._v("Acknowledgments ")])])])]), _c('a', {
    attrs: {
      "id": "page518"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0524-03-2"
    }
  }, [_c('span', [_vm._v("Thank you to my friends and family who continue to support me on this incredible journey. With each new book, I am learning to balance my time a little better, and your patience with my tight deadlines is much appreciated. My friendships and personal relationships are important to me, and I will always find the time to nourish them.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0524-04-4"
    }
  }, [_c('span', [_vm._v("Patrick, thank you for providing me with an environment that affords me this grand opportunity to live my dreams—dreams of writing full-time and of living the rest of my life with you, my forever love.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0524-05-6"
    }
  }, [_c('span', [_vm._v("Eric and Cory, dreams do come true. Work hard, strive to be the best you can be, and maintain a relationship with God. Talk to Him as you would a dear friend. He listens. He blessed me with the two of you.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0524-06-8"
    }
  }, [_c('span', [_vm._v("To Natalie Hanemann—I’m so blessed to have you in my life, as both editor and friend. You push me to hit my writing potential, and I always end up with a better book after your input. Equally important is the friendship we share. God puts people in our lives for a reason, and I feel sure He was smiling when He introduced the two of us. Thank you for everything. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0524-06-9"
    }
  }, [_c('span', [_vm._v("My entire fiction family at Thomas Nelson is awesome. I am so honored to be a part of this group. I thank God for each and every one of you.")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0525-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page518"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "id": "page519"
    }
  }, [_vm._v("Thank you to LB Norton for your editorial assistance. It was a pleasure to work with you.")])]), _c('a', {
    attrs: {
      "id": "page519"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0525-02-2"
    }
  }, [_c('span', [_vm._v("A sincere thanks to my dear friend Barbie Beiler. As always, your Amish and Mennonite background helps me to keep the books authentic. You always make time amid your busy schedule to read the manuscripts prior to publication, and I am so grateful to you. You are a blessing in my life, my friend.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0525-03-4"
    }
  }, [_c('span', [_vm._v("To Anna B. King, thank you so much for the time you spent on the phone with me, making sure that I understood the details of Christmas as celebrated in an Old Order Amish community. By the time this book goes to print, I will have met you in person in Pennsylvania, and I am really looking forward to that—to meeting Barbie’s mom!")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0525-04-6"
    }
  }, [_c('span', [_vm._v("Thank you to my agent, Mary Sue Seymour. You are a special person, and I value our professional relationship as well as our friendship. Thank you for everything.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0525-05-8"
    }
  }, [_c('span', [_vm._v("Special thanks to those “first responders” who read behind me as I write—Reneé Bissmeyer, Rene Simpson, and my wonderful mother, Pat Isley. You all keep me on my toes and push me forward to completion. Rene, thank you for reading behind me on this particular novella and for all your input.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0525-06-10"
    }
  }, [_c('span', [_vm._v("To my friends and “sistas” who constantly promote the books, thank you so much. Just to name a few—Laurie, Dawn, Melody, Valarie, Pat, Carol, Amy, Bethany, and Gayle. You gals are great!")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0525-07-12"
    }
  }, [_c('span', [_vm._v("And always, my most heartfelt thanks goes to God for providing me with this wonderful opportunity to spread His Word through inspirational stories about faith, hope, and love.")]), _c('br'), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8b902a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter59.vue
// module id = 69
// module chunks = 0